import React, { lazy, Suspense } from 'react';

const LazyDriverManagement = lazy(() => import('./DriverManagement'));

const DriverManagement = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazyDriverManagement {...props} />
  </Suspense>
);

export default DriverManagement;
